function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group 14"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group 18"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 3",
  y: 3,
  width: 40,
  height: 40,
  rx: 20,
  fill: "#39FF14"
})), /*#__PURE__*/React.createElement("rect", {
  id: "svg-button",
  x: 2.5,
  y: 0.5,
  width: 39,
  height: 39,
  rx: 19.5,
  fill: "#C58FFF",
  stroke: "black"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M28.7925 21.8075V26.7925H26.3275V22.4C26.3275 21.8574 26.3257 21.1743 26.1097 20.6278C25.9988 20.3473 25.8272 20.09 25.5614 19.9045C25.295 19.7187 24.9555 19.62 24.535 19.62C24.1169 19.62 23.769 19.7018 23.485 19.859C23.1996 20.017 22.9935 20.2431 22.8477 20.5073C22.5625 21.024 22.505 21.6928 22.505 22.32V26.7925H20.0425V17.7475H22.3875V18.8025V19.0525H22.6375H22.6775H22.8284L22.8987 18.919C23.2525 18.2473 24.137 17.51 25.485 17.51C26.9259 17.51 27.7227 17.9787 28.1791 18.7032C28.6522 19.4543 28.7925 20.5279 28.7925 21.8075ZM31.2 9.75H12.8C12.2194 9.75 11.75 10.2194 11.75 10.8V29.2C11.75 29.7806 12.2194 30.25 12.8 30.25H31.2C31.7806 30.25 32.25 29.7806 32.25 29.2V10.8C32.25 10.2194 31.7806 9.75 31.2 9.75ZM17.6825 26.7925H15.215V17.7475H17.6825V26.7925ZM16.45 15.9425C16.1593 15.9425 15.8751 15.8563 15.6333 15.6948C15.3916 15.5332 15.2032 15.3037 15.0919 15.035C14.9806 14.7664 14.9515 14.4709 15.0082 14.1857C15.065 13.9006 15.205 13.6386 15.4106 13.4331C15.6161 13.2275 15.8781 13.0875 16.1632 13.0307C16.4484 12.974 16.7439 13.0031 17.0125 13.1144C17.2812 13.2257 17.5107 13.4141 17.6723 13.6558C17.8337 13.8975 17.9199 14.1816 17.92 14.4722C17.9177 15.2848 17.2589 15.9425 16.45 15.9425Z",
  fill: "#39FF14",
  stroke: "black",
  strokeWidth: 0.5
}));

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3e431eb4.svg";
export { ForwardRef as ReactComponent };